/* eslint-disable import/prefer-default-export */

import {
  TABLE_OF_CONTENTS_OPEN,
  TABLE_OF_CONTENTS_CLOSE,
  TABLE_OF_CONTENTS_SET_SELECTED,
  TABLE_OF_CONTENTS_PRINT_CLOSE,
  TABLE_OF_CONTENTS_CONSUME_SUPPRESS_NEXT_LOCATION_CHANGE,
} from '../constants';

export function openTableOfContents({ suppressNextLocationChange = false } = {}) {
  return dispatch => {
    dispatch({
      type: TABLE_OF_CONTENTS_OPEN,
      payload: { suppressNextLocationChange },
    });
  };
}

export function consumeSuppressNextLocationChange() {
  return dispatch => {
    dispatch({
      type: TABLE_OF_CONTENTS_CONSUME_SUPPRESS_NEXT_LOCATION_CHANGE,
    });
  };
}

export function closeTableOfContents() {
  return dispatch => {
    dispatch({
      type: TABLE_OF_CONTENTS_CLOSE,
    });
  };
}

export function closeTOCBeforePrinting(isPrintTriggeredFromUI = false) {
  return dispatch => {
    dispatch({
      type: TABLE_OF_CONTENTS_PRINT_CLOSE,
      payload: {
        isPrintTriggeredFromUI,
      },
    });
  };
}

export function setSelectedTableOfContents(selected) {
  if (selected?.book?.isbn) {
    return dispatch => {
      dispatch({
        type: TABLE_OF_CONTENTS_SET_SELECTED,
        payload: {
          selected,
        },
      });
    };
  }
  return () => {};
}
